import './LoadingSpinner.css';


export const LoadingSpinner = () => {
    return (
        <div className="spinnerContainer">
            <div className="loadingSpinner"></div>
        </div>


    )
}